// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1cqxw","header":"PatientBlock_header__373xP","label":"PatientBlock_label__i6g4b","option":"PatientBlock_option__3powa"};